import { PatientId } from "../../messages";

export const outsourcingAgencyQueryKey = (patientId: PatientId) => ["outsourcingAgency", patientId];
